import moment from 'moment'
export function utcDateTimeToLocal (date: string) {
  if (!date) {
    return '-'
  }
  return moment(date).format('YYYY-MM-DD HH:mm:ss')
}

export function utcDateTimeToDate (date: string) {
  if (!date) {
    return '-'
  }
  return moment(date).format('YYYY-MM-DD ')
}

export function formatDate (date: string | number) {
  if (!date) {
    return '-'
  }
  return moment(date).format('YYYY-MM-DD')
}

export function formatWeixinDate (date: string | number) {
  if (!date) {
    return '-'
  }
  return moment(date, 'YYYYMMDDhhmmss').format('YYYY-MM-DD HH:mm:ss')
}
